import React from 'react';
import PosterInput from '../../../../uiToolkit/Inputs/PosterInput';
import {courseEditText} from '../../courseEditText';

interface Props {
  image?: File;
  existingImage?: string;
  onChange: (file?: File) => void;
}

const CoursePosterInput = React.memo(
  ({image, existingImage, onChange}: Props) => (
    <PosterInput
      image={image}
      existingImage={existingImage}
      onChange={onChange}
      text={{
        heading: courseEditText.PosterHeading,
        replace: courseEditText.posterReplace,
        remove: courseEditText.posterRemove,
        emptyTitle: courseEditText.posterEmptyTitle,
        emptyHint: courseEditText.posterEmptyHint,
        hint: courseEditText.posterShownHint,
        hintEmpty: courseEditText.posterOptionalHint,
      }}
    />
  ),
);

export default CoursePosterInput;
